import AdminLinearDiagram from './AdminLinearDiagram';

export default AdminLinearDiagram;
